module.exports = __webpack_public_path__ + "static/media/preview_merchandise.c8b61d46.PNG";